import { render } from "./AdminAccountManageListPage.vue?vue&type=template&id=224ea2f8&lang=true"
import script from "./AdminAccountManageListPage.vue?vue&type=script&lang=js"
export * from "./AdminAccountManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__